'use client';

import { AppToolbar } from '../../features/admin-shared/components/app-toolbar';
import { ADMIN_TOOLBAR_DEMO_NOTIFICATION_COUNT } from '../../features/admin-shared/lib/admin-toolbar-defaults';

/** Client boundary: `AppToolbar` needs handlers (`onOpen`, etc.) from a client module. */
export function AppShellToolbar() {
  return (
    <AppToolbar
      notifications={{
        count: ADMIN_TOOLBAR_DEMO_NOTIFICATION_COUNT,
        onOpen: () => {
          /* TODO: notifications panel / route */
        },
      }}
    />
  );
}
